<!--
 * @Description: 选择群聊
 * @Author: yuxin
 * @Date: 2025-08-01 10:53:41
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-08-18 17:48:19
 * @FilePath: \mgr_web\src\views\group\components\addGroup.vue
-->
<template>
  <div class="addGroup-container">
    <el-dialog
      title="添加群聊"
      :visible.sync="groupVisible"
      :close-on-click-modal="false"
      width="80%"
      close-on-press-escape
      center
      @close="close"
      v-loading="loading"
      top="2vh"
    >
      <div class="cus-chat-supervise-search">
        <el-form :inline="true">
          <el-form-item label="群名称：">
            <el-input
              v-model="formInline.chatName"
              size="mini"
              clearable
              @change="selectBindStatus"
            />
          </el-form-item>
          <el-form-item label="群主：">
            <el-input
              v-model="formInline.ownerName"
              size="mini"
              clearable
              @change="selectBindStatus"
            />
          </el-form-item>
          <el-form-item label="群标签：">
            <el-cascader
              v-model="searchTagItem"
              :options="tagList"
              :props="tagProps"
              size="mini"
              @change="selectTagItem"
              :show-all-levels="false"
            />
          </el-form-item>
          <el-form-item label="建群时间：">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small"
              @change="selectBindStatus"
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </el-form>
      </div>
      <el-table
        size="small"
        :data="tableData"
        fit
        highlight-current-row
        align="center"
        :header-cell-style="{ background: '#eef1f6' }"
        height="500"
        ref="multipleTable"
        @select="handleSelectionChange"
        :row-key="getRowKeys"
      >
        <!-- 自定义选择列 - 隐藏全选按钮 -->
        <el-table-column
          type="selection"
          reserve-selection
          width="55"
          :selectable="selectable"
        >
          <template slot="header">
            <!-- 空模板隐藏全选按钮 -->
          </template>
        </el-table-column>
        <el-table-column
          prop="chatName"
          label="群名称"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column prop="ownerName" label="群主" align="center">
        </el-table-column>
        <el-table-column
          prop="groupChatTagDetailDtoList"
          label="群标签"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              v-for="item in scope.row.groupChatTagDetailDtoList"
              :key="item.tagId"
              size="small"
              style="margin: 3px"
            >
              <el-popover placement="bottom-start" width="150" trigger="hover">
                <span slot="reference">{{ item.tagName }}</span>
                <el-tag
                  v-for="item in scope.row.groupChatTagDetailDtoList"
                  :key="item.tagId"
                  size="small"
                  style="margin: 3px"
                  >{{ item.tagName }}</el-tag
                >
              </el-popover>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="memNum" label="群人数" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="建群时间" align="center">
        </el-table-column>
      </el-table>
      <!-- <Pagination
        v-bind:childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination> -->
          <div class="staff-pagination">
      <el-pagination
        class="pagination-wrap"
        @current-change="currentChange"
        @size-change="sizeChange"
        :current-page.sync="formInline.pageNum"
        :page-size.sync="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="formInline.total"
        :page-sizes="[20, 50, 100, 200, 500]"
      >
      </el-pagination>
          </div>
      <div style="text-align: right; margin-top: 20px">
        <el-button size="mini" @click="handleCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="handleSumbit"
          >选择</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getList,
  getTagList,
  getGroupMessage,
  addTagItems,
  deleteGroupTags,
} from "@/api/group/index.js";
import dayjs from "dayjs";
import { Row } from "element-ui";
export default {
  data() {
    return {
      /** 存储列表数据 */
      tableData: [],
      groupVisible: false,
      /** 分页参数 */
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10,
      },
      /** 搜索参数 */
      formInline: {
        pageNum: 1,
        pageSize: 20,
        /** 群名称 */
        chatName: "",
        /** 群主 */
        ownerName: "",
        tagId: [],
        /** 建群开始时间 */
        startTime: "",
        /** 建群结束时间 */
        endTime: "",
        total: 10,
      },
      /** 分页参数 */
      pageSizes: [20, 50, 100, 200, 500],
      /** 存储时间数据 */
      date: null,
      tagList: [],
      tagVisible: false,
      currentTagId: "",
      /** 群标签数据 */
      tagProps: {
        multiple: true, //是否允许多选
        label: "tagName",
        value: "tagId",
        children: "groupChatTagDetailDtoList",
        showAllLevels: false,
      },
      // addTagItem: [],
      searchTagItem: [],
      handleTag: false, //打标签是否可见
      handleChat: false, //聊天记录是否可见
      handleDta: false, //可同步数据是否可见
      /** 是否新版本会话 true新版 false旧版*/
      isNewEdition: true,
      // 提示实例，防止弹出多个提示
      messageInstance: null,
      /** 存储选中数据 */
      selectData: [],
      /** 禁止选中未来日期 */
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      /** 控制弹窗加载动画 */
      loading: false,
    };
  },
  methods: {
    /** 初始化 */
    init(chatList) {
      console.log("sdfsfsdfs", chatList);
      // this.selectData2 = [...chatList];
      this.selectData = [...chatList];
      this.groupVisible = true;
      /** 获取筛选所需要的群标签数据 */
      this.getTag();
      this.$nextTick(() => {
        this.getDataList();
      });
    },

    /** 获取群聊列表 */
    getDataList() {
      this.loading = true;
      // this.formInline.pageNum  = this.pageparm.currentPage
      // this.formInline.pageSize  = this.pageparm.pageSize
      // const requestParams = {
      //   ...this.formInline,
      //   ...this.pageparm
      // }
      getList(this.formInline, localStorage.getItem("Authorization")).then(
        (res) => {
          if (res && res.error && res.error.code == 200) {
            if (res.data.rows && res.data.rows.length > 0) {
              this.tableData = res.data.rows;
              this.formInline.total =  res.data.count;
              // 清空当前选中状态
              // this.$refs.multipleTable.clearSelection();
              // console.log("sfsfsdfsdfsdfs", this.selectData2);
              this.$nextTick(() => {
                this.tableData.forEach((row) => {
                  console.log("row+++", row);
                  if (
                    this.selectData.some((item) => item.chatId === row.chatId)
                  ) {
                    this.$refs.multipleTable.toggleRowSelection(row, true);
                  }
                });
              });
            } else {
              this.tableData = [];
              this.formInline.total = 0;
            }
          }
          this.loading = false;
        }
      );
    },

    /** 表格多选 */
    handleSelectionChange(val, row) {
      console.log("val1", row);
      console.log("row1", row);
      console.log(val);
      this.selectData.some((item) => {
        return item.chatId === row.chatId;
      });
      if (!this.selectData.some((item) => item.chatId === row.chatId)) {
        this.selectData.push(row);
      } else {
        this.selectData.forEach((item, index) => {
          if (item.chatId == row.chatId) {
            this.selectData.splice(index, 1);
          }
        });
      }
      console.log("+++++dasdsd", this.selectData);
    },

    /** 控制行是否可选 */
    selectable(row) {
      console.log("fgdgdf", this.selectData.length);

      // 如果当前行已被选中，则始终可选（为了允许取消选择）
      if (this.selectData.some((item) => item.chatId === row.chatId)) {
        return true;
      }
      // 如果尚未达到上限，则允许选择
      return this.selectData.length < 5;
    },

    /** 群标签变化触发 */
    selectTagItem(list) {
      let tagList = [];
      if (list.length > 0) {
        list.forEach((item) => {
          tagList.push(item[1]);
        });
      }
      this.formInline.tagId = [...tagList];
      this.formInline.pageNum = 1;
      // this.pageparm.pageNum = this.formInline.pageNum
      this.getDataList();
    },

    /** 筛选条件变化 */
    selectBindStatus() {
      // this.formInline.pageNum = 1;
      if (this.date != null) {
        this.formInline.startTime = dayjs(this.date[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formInline.endTime =
          dayjs(this.date[1]).format("YYYY-MM-DD") + " " + "23:59:59";
      } else {
        this.formInline.startTime = "";
        this.formInline.endTime = "";
      }
      this.formInline.pageNum = 1;
      this.getDataList();
    },

    /** 页码改变回调 */
    currentChange(parm) {
      console.log("sdfsdfsdfdfgtre", parm);
      this.formInline.pageNum = parm;

      this.getDataList();
    },

    /** 页数改变回调 */
    sizeChange(parm) {
      console.log("sdfsdfsdfdfgtre1", parm);
      this.formInline.pageSize = parm;

      this.getDataList();
    },

    /** 点击选择按钮触发 */
    handleSumbit() {
      if (this.selectData && this.selectData.length < 1) {
        this.$message.closeAll();
        return this.$message.warning("请最少选择一个");
      }
      if (this.selectData && this.selectData.length > 5) {
        this.$message.closeAll();
        return this.$message.warning("最多只能选择5个");
      }
      this.$emit("getSelectedGroup", this.selectData);
      this.groupVisible = false;
    },

    /** 点击取消触发 */
    handleCancel() {
      this.close();
    },

    /** 关闭弹窗触发 */
    close() {
      this.tagVisible = false;
      this.$emit("closeGroupDia");
    },

    getRowKeys(row) {
      return row.chatId;
    },
    /** 获取检索条件的群标签 */
    getTag() {
      getTagList(localStorage.getItem("Authorization")).then((res) => {
        console.log(res);
        this.tagList = res.data.map((item) => {
          return { ...item, tagName: item.groupName };
        });
      });
    },
  },

  updated() {
    this.$nextTick(() => {
      this.$refs["multipleTable"].doLayout();
    });
  },

  // mounted: function() {
  //   // this.controlHeight();
  // },

  /** 计算属性 */
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },

  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        console.log("XXXXXXXX", newVal);
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "群列表") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("qglkdbq") != -1) {
                // 可打标签
                this.handleTag = true;
              } else {
                this.handleTag = false;
              }
              if (senBtnAuthority.indexOf("qglkckltjl") != -1) {
                // 可查询聊天记录
                this.handleChat = true;
              } else {
                this.handleChat = false;
              }
              if (senBtnAuthority.indexOf("qglktbsj") != -1) {
                // 可同步数据按钮
                this.handleDta = true;
              } else {
                this.handleDta = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.query": {
      handler(oldVal, newVal) {
        console.log("监听路由", oldVal);
        if (oldVal && oldVal.startTime && oldVal.endTime) {
          this.formInline.startTime = oldVal.startTime + " " + "00:00:00";
          this.formInline.endTime = oldVal.endTime + " " + "23:59:59";
          this.date = [
            oldVal.startTime + " " + "00:00:00",
            oldVal.endTime + " " + "23:59:59",
          ];
        }
      },
      deep: true,
      immediate: true,
    },
  },

  /** 生命周期 */
  // mounted: function() {
  //   this.controlHeight();
  // },

  /** 生命周期 */
  created() {
    // this.getDataList(this.formInline);
    // this.getTag();
  },
};
</script>
<style lang="scss" scoped>
.addGroup-container {
  width: 100%;
  height: 100%;
  .cus-chat-supervise-search {
    margin-bottom: 10px;
  }

  // .el-dialog {
  //   min-width: 620px;
  //   max-width: 1200px;
  // }

  // .el-dialog__title {
  //   line-height: 24px;
  //   font-size: 16px;
  //   font-weight: bold;
  //   color: #0f0f0f;
  // }

  .el-dialog__body {
    padding: 5px 30px 20px !important;
  }

  /* 隐藏表头中的全选复选框 */
  /deep/.el-table__header-wrapper .el-checkbox {
    display: none !important;
  }

  .pagination-wrap {
    margin-top: 20px;
  }
    .staff-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 40px;
  }
}
</style>
